import qwest from 'qwest';

import Notification from '../models/notification.jsx';

let NotificationApi = {

  list() {
    return qwest.get('/Notification/Index')
      .then((xhr, response) => {
        if (response.success) {
          return response.data.map(n => Notification.fromApiFormat(n));
        }
        throw response;
      });
  },

  unread() {
    return qwest.get('/Notification/Unread')
      .then((xhr, response) => {
        if (response.success) {
          return response.data.map(n => Notification.fromApiFormat(n));
        }
        throw response;
      });
  },

  unreadCount() {
    return qwest.getOnline('/Notification/UnreadCount')
      .then((xhr, response) => {
        if (response.success) {
          return response.data;
        }
        throw response;
      });
  },

  save(notification) {
    return qwest.post('/Notification/Index', notification.toApiFormat())
      .then((xhr, response) => {
        if (response.success) {
          return response.data.map(n => Notification.fromApiFormat(n));
        }
        throw response;
      });
  },

};

export default NotificationApi;
